import type CalendarActionResponse from 'owa-service/lib/contract/CalendarActionResponse';
import type CalendarColor from 'owa-service/lib/contract/CalendarColor';
import itemId from 'owa-service/lib/factory/itemId';
import setCalendarColorOperation from 'owa-service/lib/operation/setCalendarColorOperation';
import type { CalendarId } from 'owa-graph-schema';
import { getMailboxRequestOptions } from 'owa-request-options-types';

/**
 * sets calendar color on server
 * @param id id of the calendar that needs to be deleted
 * @param calendarColor the calendar color to set
 */
export default function setCalendarColorService(
    calendarId: CalendarId,
    calendarColor: CalendarColor
): Promise<CalendarActionResponse> {
    return setCalendarColorOperation(
        {
            itemId: itemId({ Id: calendarId.id, ChangeKey: calendarId.changeKey }),
            calendarColor: calendarColor,
        },
        getMailboxRequestOptions(calendarId.mailboxInfo)
    );
}
